import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { provideTranslate } from '@gandi/react-translate';

import 'ui-kit/src/styles/ui-kit.css';
import './index.css';
import { fetchPointsOfSale, fetchFilters } from './actions/pointOfSale';
import { fetchMotives } from './actions/popin';
import loadBooxi from './services/booxi';
import loadGTM from './services/gtm';
import loadMap from './services/map';
import store from './services/store';
import translator from './services/translator';
import App from './components/App/App';

const TranslatedApp = provideTranslate(translator)(App);

loadGTM();
loadBooxi();

ReactDOM.render(
  <Provider store={store}><TranslatedApp /></Provider>,
  document.getElementById('root')
);

loadMap(store.dispatch);
fetchPointsOfSale(store.dispatch);
fetchFilters(store.dispatch);
fetchMotives(store.dispatch);



// WEBPACK FOOTER //
// ./src/index.js